module.exports = __webpack_public_path__ + "static/img/juhuaR134A.4e8098c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR134A.jpg
// module id = PgEr
// module chunks = 1